import { Button, Modal } from 'react-bootstrap';
import { renderInputFieldWithoutLabel } from '../../common/inputField';
import { useState } from 'react';
import CustomTextField from '../../common/CustomTextField';

const DeleteModal = ({ modalOpen }) => {
  const [deleteComment, setDeleteComment] = useState('');
  const [days, setDays] = useState(
    modalOpen.existingMessage ? modalOpen.existingMessage : 0,
  );

  const handleDaysChange = (e) => {
    setDays(e.target.value);
  };

  return (
    <Modal show={modalOpen.open} onHide={modalOpen.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{modalOpen.title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {modalOpen.body}
        {modalOpen.isNumber ? (
          <CustomTextField
            type="number"
            min={0}
            onWheel={(e) => e.target.blur()}
            value={days}
            name={'donorAadharNumber'}
            onChange={handleDaysChange}
            variant="outlined"
            size="small"
            fullWidth
          />
        ) : (
          <>
            {renderInputFieldWithoutLabel(
              'deleteComment',
              deleteComment,
              (e) => {
                setDeleteComment(e.target.value);
              },
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={modalOpen.onClose}>
          {modalOpen.cancelText}
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            modalOpen.isNumber
              ? modalOpen.onSave(days)
              : modalOpen.onSave(modalOpen.notification, deleteComment);
          }}
          disabled={modalOpen.isNumber ? days <= 0 : deleteComment === ''}
        >
          {modalOpen.proceedText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
